import url from 'url';
import querystring from 'querystring';
import lodashPick from 'lodash/fp/pick';
import typeCheck from 'common/util/typeCheck';

export const MEDIA_TYPE_3D_TOUR = '3DTour';
export const MEDIA_TYPE_VIDEO = 'Video';

export const pickMediaForeignFields = lodashPick([
  'apartmentId',
  'apartmentBuildingId',
  'floorPlanId',
  'listingId',
]);

export function mediaForeignFieldsToSqlSelect(mediaProps) {
  typeCheck('mediaProps::NonEmptyObject', mediaProps);
  const mediaForeignFields = pickMediaForeignFields(mediaProps);
  return Object.keys(mediaForeignFields).reduce(
    (mediaForeignFieldsForSqlSelect, mediaForeignFieldName) => {
      return {
        [`media.${mediaForeignFieldName}`]: mediaForeignFields[mediaForeignFieldName],
        ...mediaForeignFieldsForSqlSelect,
      };
    },
  );
}

export function getMediaForeignId(mediaProps) {
  typeCheck('mediaProps::NonEmptyObject', mediaProps);
  return (
    mediaProps.apartmentId ||
    mediaProps.apartmentBuildingId ||
    mediaProps.floorPlanId ||
    mediaProps.listingId
  );
}

export function sanitizeMediaUrl(mediaUrl) {
  typeCheck('mediaUrl::NonEmptyString', mediaUrl);
  const parsedUrl = url.parse(mediaUrl);
  const parsedQuery = querystring.parse(parsedUrl.query);

  if (parsedUrl.host.includes('matterport.com') && parsedQuery.play !== '1') {
    parsedQuery.play = '1';
    parsedUrl.search = querystring.stringify(parsedQuery);
  }

  return parsedUrl.format();
}

export function getMediaForeignTable(mediaProps) {
  typeCheck('mediaProps::NonEmptyObject', mediaProps);
  if (mediaProps.apartmentId) {
    return 'apartments';
  }
  if (mediaProps.apartmentBuildingId) {
    return 'apartmentBuildings';
  }
  if (mediaProps.floorPlanId) {
    return 'floorPlans';
  }
  if (mediaProps.listingId) {
    return 'listings';
  }
}
